import React from "react";
import useStyles from "./Styles";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import ChartTitle from "./ChartTitle";
import userActions from "./actions";
import Treemap from "./Treemap";
import CentralArizonaMap from "./CentralArizonaMap";
import CentralArizonaStackBar from "./CentralArizonaStackBar";
import CentralArizonaSankey from "./CentralArizonaSankey";
import appActions from '../app/actions';

const ChartView = () => {
  const classes = useStyles();
  const {
    loadEntitlements,
    loadPriorityEntitlements,
    loadEntitlementDifference,
    setChart,
  } = userActions();
  const { chart } = useSelector((state) => state.central_arizona);
  const { setChartDrawerStateToClose } = appActions();

  const componentMount = () => {
    loadEntitlements();
    loadPriorityEntitlements();
    loadEntitlementDifference();
    return () => {
      setChart("central_arizona_shortage_impacts");
    };
  }
  React.useEffect(componentMount, []);

  return (
    <Box className={classes.chartView} onClick={()=>{ setChartDrawerStateToClose() }}>
      {chart === "central_arizona_shortage_impacts" ? (
        <ChartTitle
          floating={true}
          title={"Central Arizona Colorado River Shortage Impacts"}
          subtitle={""}
          background="#EDEDED"
        />
      ) : chart === "allocations" ? (
        <ChartTitle
          title={"Users with largest Colorado River water access (acre-feet)"}
          subtitle={""}
        />
      ) : chart === "shortage_impacts_by_community" ? (
        <ChartTitle
          title={"Shortage Impacts by Community (acre-feet)"}
          subtitle={""}
        />
      ) : chart === "shortage_impacts_by_sector" ? (
        <ChartTitle title={"Shortage Impacts by Sector"} subtitle={""} />
      ) : (
        ""
      )}

      {
        {
          central_arizona_shortage_impacts: <CentralArizonaMap />,
          allocations: <Treemap />,
          shortage_impacts_by_community: <CentralArizonaStackBar />,
          shortage_impacts_by_sector: <CentralArizonaSankey />,
        }[chart]
      }
    </Box>
  );
};

export default ChartView;
